module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "equipment"
  }, [(_vm.busy) ? _c('div', {
    staticClass: "full-box"
  }, [_c('div', {
    staticClass: "loadingWorkOrders"
  }, [_c('div', {
    staticClass: "logo"
  }), _vm._v(" "), _vm._m(0), _vm._v("\n      Loading Equipment Entries for Work Order #" + _vm._s(this.$route.params.id) + "        \n    ")])]) : _vm._e(), _vm._v(" "), (_vm.openMenu) ? [_c('div', {
    staticClass: "overlay"
  }, [_c('div', {
    staticClass: "mobile-menu"
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('div', {
    staticClass: "close-menu",
    on: {
      "click": function($event) {
        return _vm.hideMenu()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-times",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('h2', {
    staticClass: "mcText"
  }, [_vm._v(_vm._s(_vm.username))]), _vm._v(" "), _c('ul', [_c('li', {
    on: {
      "click": function($event) {
        return _vm.backToListings()
      }
    }
  }, [_vm._v("My Work Orders "), _c('i', {
    staticClass: "fa fa-list-ul",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        return _vm.logout()
      }
    }
  }, [_vm._v("Log Out "), _c('i', {
    staticClass: "fa fa-sign-out",
    attrs: {
      "aria-hidden": "true"
    }
  })])])])])])] : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "main-header"
  }, [_c('div', {
    staticClass: "top"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [(_vm.$mq.resize && _vm.$mq.above(_vm.$mv.tablet)) ? _c('div', [_c('button', {
    staticClass: "pull-right btn header-btn mcBG scBGHover",
    on: {
      "click": function($event) {
        return _vm.goBackToWO()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-reply",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Back to the Work Order")])]) : _vm._e(), _vm._v(" "), (_vm.$mq.resize && _vm.$mq.below(_vm.$mv.tablet - 1)) ? _c('div', [_c('ul', [_c('li', {
    on: {
      "click": function($event) {
        return _vm.goBackToWO()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-reply",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        return _vm.showMenu()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-bars",
    attrs: {
      "aria-hidden": "true"
    }
  })])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "logo"
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "inner-header-bar mcBG"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('img', {
    staticClass: "pull-right",
    attrs: {
      "src": "static/img/i3v_icon_white.png"
    }
  }), _vm._v(" "), (_vm.$mq.resize && _vm.$mq.below(_vm.$mv.tablet - 1)) ? _c('div', [_c('h1', [_vm._v("Enter Equipment "), _c('span', [_vm._v("[WO# " + _vm._s(_vm.workOrder) + "]")])])]) : _vm._e(), _vm._v(" "), (_vm.$mq.resize && _vm.$mq.above(_vm.$mv.tablet)) ? _c('div', [_c('h1', [_vm._v("Enter Equipment - WO# " + _vm._s(_vm.workOrder) + " ")])]) : _vm._e()])])])])]), _vm._v(" "), (_vm.$mq.resize && _vm.$mq.above(_vm.$mv.tablet)) ? _c('div', {
    staticClass: "tablet-view"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row flexrow"
  }, [_c('div', {
    staticClass: "col-sm-5"
  }, [_c('div', {
    staticClass: "inner"
  }, [(_vm.workOrderCheck.fieldComplete) ? [_c('h2', [_vm._v("Work Order is closed")]), _vm._v(" "), _vm._m(1)] : _vm._e(), _vm._v(" "), (!_vm.workOrderCheck.fieldComplete) ? [_c('h2', [_vm._v(_vm._s(_vm.leftTitle))]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.editing),
      expression: "editing"
    }],
    staticClass: "form-group"
  }, [_c('p', [_vm._v(_vm._s(_vm.introText)), _c('br'), _vm._v(" \n                To add a "), _c('strong', [_vm._v("NEW")]), _vm._v(" record, click "), _c('strong', [_c('span', {
    on: {
      "click": function($event) {
        return _vm.closeEdit()
      }
    }
  }, [_vm._v("here.")])])])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.edits.lineId),
      expression: "edits.lineId"
    }],
    attrs: {
      "type": "hidden"
    },
    domProps: {
      "value": (_vm.edits.lineId)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.edits, "lineId", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.edits.uRecID),
      expression: "edits.uRecID"
    }],
    attrs: {
      "type": "hidden"
    },
    domProps: {
      "value": (_vm.edits.uRecID)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.edits, "uRecID", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "material"
    }
  }, [_vm._v("Select Equipment")]), _vm._v(" "), _c('el-select', {
    attrs: {
      "popper-class": "popClass",
      "no-match-text": "No Equipment Found",
      "filterable": "",
      "placeholder": "Select Equipment"
    },
    model: {
      value: (_vm.edits.equipmentCode),
      callback: function($$v) {
        _vm.$set(_vm.edits, "equipmentCode", $$v)
      },
      expression: "edits.equipmentCode"
    }
  }, _vm._l((_vm.orderBy(_vm.equipment, 'description', 1)), function(eq) {
    return (eq.uMMEnabled == true) ? _c('el-option', {
      staticClass: "form-control",
      attrs: {
        "label": eq.description + ' (' + eq.equipmentCode + ')',
        "value": eq.equipmentCode
      }
    }) : _vm._e()
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "date"
    }
  }, [_vm._v("Date")]), _vm._v(" "), _c('el-date-picker', {
    attrs: {
      "format": "MM-dd-yyyy",
      "type": "date",
      "placeholder": "Pick a day"
    },
    model: {
      value: (_vm.edits.date),
      callback: function($$v) {
        _vm.$set(_vm.edits, "date", $$v)
      },
      expression: "edits.date"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "date"
    }
  }, [_vm._v("Start Time (24 hour)")]), _c('br'), _vm._v(" "), _c('el-time-picker', {
    attrs: {
      "placeholder": "Select Time",
      "format": "HH:mm"
    },
    model: {
      value: (_vm.edits.starthour),
      callback: function($$v) {
        _vm.$set(_vm.edits, "starthour", $$v)
      },
      expression: "edits.starthour"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Stop Time (24 hour)")]), _c('br'), _vm._v(" "), _c('el-time-picker', {
    attrs: {
      "placeholder": "Select Time",
      "format": "HH:mm"
    },
    model: {
      value: (_vm.edits.stophour),
      callback: function($$v) {
        _vm.$set(_vm.edits, "stophour", $$v)
      },
      expression: "edits.stophour"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "quantity"
    }
  }, [_vm._v("Charge Type")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.edits.chargeType),
      expression: "edits.chargeType"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.edits, "chargeType", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.chargeTypes), function(chargeType) {
    return _c('option', [_vm._v("\n                    " + _vm._s(chargeType) + "\n                  ")])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.editing),
      expression: "!editing"
    }],
    staticClass: "mcBG btn scBGHover btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.add()
      }
    }
  }, [_vm._v(_vm._s(_vm.buttonTitle))]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.editing),
      expression: "editing"
    }],
    staticClass: "mcBG scBGHover btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.submitEdit()
      }
    }
  }, [_vm._v(_vm._s(_vm.buttonTitle))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.busySave),
      expression: "busySave"
    }],
    staticClass: "statusMSG form-group"
  }, [_vm._v("\n                Saving New Record "), _c('i', {
    staticClass: "fa fa-refresh fa-spin",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.busyEdit),
      expression: "busyEdit"
    }],
    staticClass: "statusMSG form-group"
  }, [_vm._v("\n                Editing Existing Record "), _c('i', {
    staticClass: "fa fa-refresh fa-spin",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.submitError),
      expression: "submitError"
    }],
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "error"
  }, [_vm._v("\n                  " + _vm._s(_vm.submitErrorText) + "\n                ")])])] : _vm._e()], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('h2', [_vm._v("Existing Records")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.busyDel),
      expression: "busyDel"
    }],
    staticClass: "statusMSG form-group"
  }, [_vm._v("\n              Deleting Record "), _c('i', {
    staticClass: "fa fa-refresh fa-spin",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('ul', {
    staticClass: "innerWOListing"
  }, _vm._l((_vm.equipmentRecords), function(equipmentRecord) {
    return _c('li', {
      class: {
        mcBGactive: _vm.editingRow == equipmentRecord.lineId
      }
    }, [(!_vm.workOrderCheck.fieldComplete) ? _c('div', [_c('div', {
      staticClass: "actions"
    }, [_c('div', {
      on: {
        "click": function($event) {
          return _vm.edit(equipmentRecord.lineId, equipmentRecord.equipmentCode, equipmentRecord.timeStart, equipmentRecord.timeEnd, equipmentRecord.chargeType, equipmentRecord.uRecId)
        }
      }
    }, [_c('i', {
      staticClass: "mcTextHover fa fa-pencil-square-o",
      attrs: {
        "aria-hidden": "true"
      }
    })]), _vm._v(" "), _c('div', {
      on: {
        "click": function($event) {
          return _vm.del(equipmentRecord.lineId)
        }
      }
    }, [_c('i', {
      staticClass: "mcTextHover fa fa-times",
      attrs: {
        "aria-hidden": "true"
      }
    })])])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "top-row"
    }, [_vm._l((_vm.equipment), function(eq) {
      return (eq.equipmentCode == equipmentRecord.equipmentCode) ? _c('span', [_vm._v(" \n                  " + _vm._s(eq.description))]) : _vm._e()
    }), _vm._v(" - " + _vm._s(_vm._f("moment")(equipmentRecord.timeStart, "MMM Do, YYYY")) + "\n                ")], 2), _vm._v("\n                " + _vm._s(_vm._f("moment")(equipmentRecord.timeStart, "hh:mm a")) + " - " + _vm._s(_vm._f("moment")(equipmentRecord.timeEnd, "hh:mm a")) + " | " + _vm._s(equipmentRecord.chargeType) + "\n              ")])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('div', {
    staticClass: "inner-dark"
  }, [_c('h3', {
    staticClass: "mcText"
  }, [_c('span', [_vm._v("Username")]), _vm._v("\n            " + _vm._s(_vm.username))]), _vm._v(" "), _c('ul', [_c('li', {
    on: {
      "click": function($event) {
        return _vm.backToListings()
      }
    }
  }, [_vm._v("My Work Orders "), _c('i', {
    staticClass: "fa fa-list-ul",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        return _vm.enterMaterial()
      }
    }
  }, [_vm._v("Enter Materials "), _c('i', {
    staticClass: "fa fa-wrench",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        return _vm.enterLabor()
      }
    }
  }, [_vm._v("Enter Labor "), _c('i', {
    staticClass: "fa fa-user-circle",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        return _vm.logout()
      }
    }
  }, [_vm._v("Log Out "), _c('i', {
    staticClass: "fa fa-sign-out",
    attrs: {
      "aria-hidden": "true"
    }
  })])])])])])])]) : _vm._e(), _vm._v(" "), (_vm.$mq.resize && _vm.$mq.below(_vm.$mv.tablet - 1)) ? _c('div', [_c('div', {
    staticClass: "mobile-view"
  }, [_c('div', {
    staticClass: "lem-formTop"
  }, [(_vm.workOrderCheck.fieldComplete) ? [_c('h2', [_vm._v("Work Order is closed")]), _vm._v(" "), _vm._m(2)] : _vm._e(), _vm._v(" "), (!_vm.workOrderCheck.fieldComplete) ? [_c('h2', [_vm._v(_vm._s(_vm.leftTitle))]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.editing),
      expression: "editing"
    }],
    staticClass: "form-group"
  }, [_c('p', [_vm._v(_vm._s(_vm.introText)), _c('br'), _vm._v(" \n            To add a "), _c('strong', [_vm._v("NEW")]), _vm._v(" record, click "), _c('strong', [_c('span', {
    on: {
      "click": function($event) {
        return _vm.closeEdit()
      }
    }
  }, [_vm._v("here.")])])])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.edits.lineId),
      expression: "edits.lineId"
    }],
    attrs: {
      "type": "hidden"
    },
    domProps: {
      "value": (_vm.edits.lineId)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.edits, "lineId", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.edits.uRecID),
      expression: "edits.uRecID"
    }],
    attrs: {
      "type": "hidden"
    },
    domProps: {
      "value": (_vm.edits.uRecID)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.edits, "uRecID", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-xs-12"
  }, [_c('label', {
    attrs: {
      "for": "material"
    }
  }, [_vm._v("Select Equipment")]), _vm._v(" "), _c('el-select', {
    attrs: {
      "popper-class": "popClass",
      "no-match-text": "No Equipment Found",
      "filterable": "",
      "placeholder": "Select Equipment"
    },
    model: {
      value: (_vm.edits.equipmentCode),
      callback: function($$v) {
        _vm.$set(_vm.edits, "equipmentCode", $$v)
      },
      expression: "edits.equipmentCode"
    }
  }, _vm._l((_vm.orderBy(_vm.equipment, 'description', 1)), function(eq) {
    return (eq.uMMEnabled == true) ? _c('el-option', {
      staticClass: "form-control",
      attrs: {
        "label": eq.description + ' (' + eq.equipmentCode + ')',
        "value": eq.equipmentCode
      }
    }) : _vm._e()
  }), 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-xs-6"
  }, [_c('label', {
    attrs: {
      "for": "date"
    }
  }, [_vm._v("Date")]), _vm._v(" "), _c('el-date-picker', {
    attrs: {
      "editable": false,
      "type": "date",
      "format": "MM-dd-yyyy",
      "placeholder": "Pick a day"
    },
    model: {
      value: (_vm.edits.date),
      callback: function($$v) {
        _vm.$set(_vm.edits, "date", $$v)
      },
      expression: "edits.date"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group col-xs-6"
  }, [_c('label', {
    attrs: {
      "for": "quantity"
    }
  }, [_vm._v("Charge Type")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.edits.chargeType),
      expression: "edits.chargeType"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.edits, "chargeType", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.chargeTypes), function(chargeType) {
    return _c('option', [_vm._v("\n                    " + _vm._s(chargeType) + "\n                  ")])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-xs-6"
  }, [_c('label', {
    attrs: {
      "for": "date"
    }
  }, [_vm._v("Start Time")]), _c('br'), _vm._v(" "), _c('el-time-picker', {
    attrs: {
      "editable": false,
      "placeholder": "Select Time",
      "format": "HH:mm"
    },
    model: {
      value: (_vm.edits.starthour),
      callback: function($$v) {
        _vm.$set(_vm.edits, "starthour", $$v)
      },
      expression: "edits.starthour"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group col-xs-6"
  }, [_c('label', [_vm._v("Stop Time")]), _c('br'), _vm._v(" "), _c('el-time-picker', {
    attrs: {
      "editable": false,
      "placeholder": "Select Time",
      "format": "HH:mm"
    },
    model: {
      value: (_vm.edits.stophour),
      callback: function($$v) {
        _vm.$set(_vm.edits, "stophour", $$v)
      },
      expression: "edits.stophour"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-xs-12"
  }, [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.editing),
      expression: "!editing"
    }],
    staticClass: "mcBG btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.add()
      }
    }
  }, [_vm._v(_vm._s(_vm.buttonTitle))]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.editing),
      expression: "editing"
    }],
    staticClass: "mcBG btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.submitEdit()
      }
    }
  }, [_vm._v(_vm._s(_vm.buttonTitle))])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.busySave),
      expression: "busySave"
    }],
    staticClass: "statusMSG form-group col-xs-12"
  }, [_vm._v("\n                Saving New Record "), _c('i', {
    staticClass: "fa fa-refresh fa-spin",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.busyEdit),
      expression: "busyEdit"
    }],
    staticClass: "statusMSG form-group col-xs-12"
  }, [_vm._v("\n                Editing Existing Record "), _c('i', {
    staticClass: "fa fa-refresh fa-spin",
    attrs: {
      "aria-hidden": "true"
    }
  })])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.submitError),
      expression: "submitError"
    }],
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "error"
  }, [_vm._v("\n                  " + _vm._s(_vm.submitErrorText) + "\n                ")])])] : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "lem-dividingCount"
  }, [_vm._v("\n        " + _vm._s(_vm.equipmentRecords.length) + " Records\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "lem-listingBottom"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.busyDel),
      expression: "busyDel"
    }],
    staticClass: "statusMSG form-group"
  }, [_vm._v("\n          Deleting Record "), _c('i', {
    staticClass: "fa fa-refresh fa-spin",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('ul', {
    staticClass: "innerWOListing"
  }, _vm._l((_vm.equipmentRecords), function(equipmentRecord) {
    return _c('li', {
      class: {
        mcBGactive: _vm.editingRow == equipmentRecord.lineId
      }
    }, [(!_vm.workOrderCheck.fieldComplete) ? _c('div', [_c('div', {
      staticClass: "actions"
    }, [_c('div', {
      on: {
        "click": function($event) {
          return _vm.edit(equipmentRecord.lineId, equipmentRecord.equipmentCode, equipmentRecord.timeStart, equipmentRecord.timeEnd, equipmentRecord.chargeType, equipmentRecord.uRecId)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil-square-o",
      attrs: {
        "aria-hidden": "true"
      }
    })]), _vm._v(" "), _c('div', {
      on: {
        "click": function($event) {
          return _vm.del(equipmentRecord.lineId)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-times",
      attrs: {
        "aria-hidden": "true"
      }
    })])])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "top-row"
    }, [_vm._l((_vm.equipment), function(eq) {
      return (eq.equipmentCode == equipmentRecord.equipmentCode) ? _c('span', [_vm._v(" " + _vm._s(eq.description))]) : _vm._e()
    }), _vm._v(" - " + _vm._s(_vm._f("moment")(equipmentRecord.timeStart, "MMM Do, YYYY")) + "\n                ")], 2), _vm._v("\n                " + _vm._s(_vm._f("moment")(equipmentRecord.timeStart, "hh:mm a")) + " - " + _vm._s(_vm._f("moment")(equipmentRecord.timeEnd, "hh:mm a")) + " | " + _vm._s(equipmentRecord.chargeType) + "\n              ")])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "mobileBottomBar"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-4",
    on: {
      "click": function($event) {
        return _vm.enterLabor()
      }
    }
  }, [_vm._v("\n            Labor "), _c('span', {
    staticClass: "mcText"
  }, [_vm._v("(" + _vm._s(_vm.laborRecords.length) + ")")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4 active center"
  }, [_vm._v("\n            Equipment "), _c('span', {
    staticClass: "mcText"
  }, [_vm._v("(" + _vm._s(_vm.equipmentRecords.length) + ")")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4",
    on: {
      "click": function($event) {
        return _vm.enterMaterial()
      }
    }
  }, [_vm._v("\n            Materials "), _c('span', {
    staticClass: "mcText"
  }, [_vm._v("(" + _vm._s(_vm.materialRecords.length) + ")")])])])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('pre', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }]
  }, [_vm._v("    " + _vm._s(_vm.$data.laborRecords) + "\n  ")])])], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loading-image"
  }, [_c('i', {
    staticClass: "fa fa-circle-o-notch fa-spin fa-3x fa-fw mcText"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('p', [_vm._v("This Work Order is closed, so you will not be able to add any new "), _c('strong', [_vm._v("equipment")]), _vm._v(" entries or edit any existing entries.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('p', [_vm._v("This Work Order is closed, so you will not be able to add any new "), _c('strong', [_vm._v("equipment")]), _vm._v(" entries or edit any existing entries.")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-18ce820f!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Equipment.vue
// module id = 855
// module chunks = 2